<template>
  <div class="w-full">
    <cardTitle title="今日风险作业管控情况" cardType='shimen' />
    <v-chart
      :options="riskyOperations"
      class="!h-[calc(100%-62px)] !w-full"
      :autoresize="true"
    ></v-chart>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitService from '../../service/index'

export default {
  name: '',
  components: { CardTitle },

  props: [],
  data() {
    return {
      initInterval: null,
      riskyOperations: {
        color: [],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          bottom: '5%',
          left: 'center',
          itemWidth: 15,
          itemHeight: 15,
          itemGap: 15,
          textStyle: {
            color: '#fff',
            padding: [2, 0, 0, 0],
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 0, name: '低风险', itemStyle: { color: '#409eff' } },
              { value: 0, name: '一般风险', itemStyle: { color: '#ffff00' } },
              { value: 0, name: '较大风险', itemStyle: { color: '#FFA500' } },
              { value: 0, name: '重大风险', itemStyle: { color: '#ff0000' } },
            ],
          },
        ],
      },
    }
  },
  methods: {
    async getHighRiskStatistics() {
      const [err, res] = await CockpitService.getHighRiskStatistics()
      if (res && res.code === 0 && res.data) {
        this.riskyOperations.series[0].data[0].value = res.data.lowNumber
        this.riskyOperations.series[0].data[1].value = res.data.generalNumber
        this.riskyOperations.series[0].data[2].value = res.data.significantNumber
        this.riskyOperations.series[0].data[3].value = res.data.majorNumber
      }
      console.log(res)
    },
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },
  mounted() {
    this.getHighRiskStatistics()
    this.initInterval = setInterval(() => {
      this.getHighRiskStatistics()
    }, 5000)
  },
}
</script>

<style lang="scss" scoped>
</style>
